module.exports = __webpack_public_path__ + "static/media/adesivo_big.e418b62f.png";